/**
 * 移动端适配中间件 - 增强版
 */

export default function ({
  req, store, redirect, route, res,
}) {
  // 客户端环境不执行
  if (process.client) return;

  // 短链接服务路由阻止touch端跳转
  if (route.name === 'j-id') {
    return
  }

  const userAgent = req.headers['user-agent'];
  const isTouchDevice = /Android(?=.*Mobile)|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  // Googlebot 未编入索引的原因是因为重定向，Googlebot是爬虫测试的ua这个不是真实用户，加这个是为了跳过限制，让google能收录web端
  const isGooglebot = /(googlebot|adsbot-google|mediapartners-google)/i.test(userAgent);
  // const platform = isTouchDevice ? 'touch' : 'pc';

  // console.log('req.ctx.request.url', req.ctx.request.url);
  // console.log('route', route);
  // console.log('platform', platform);

  // 获取当前请求URL和域名信息
  const requestUrl = req.ctx.request.url;
  const currentHost = req.headers.host;

  // 获取配置的域名信息
  const touchDomains = process.env.touchDomains || {};
  const pcDomains = process.env.pcDomains || {};
  const currentLocale = store.state.locale;

  // 获取当前语言环境对应的域名
  const touchDomain = touchDomains[currentLocale];
  const pcDomain = pcDomains[currentLocale];

  // 移动端访问PC域名，重定向到移动端域名
  if (isTouchDevice && !isGooglebot && pcDomain && pcDomain.includes(currentHost)) {
    const touchUrl = `${touchDomain}${requestUrl}`;
    console.log(`移动端设备访问PC域名，重定向到: ${touchUrl}`);

    if (process.server) {
      res.writeHead(301, { Location: touchUrl });
      res.end();
    } else {
      redirect(301, touchUrl);
    }
  }
}
